module.exports = __webpack_public_path__ + "img/new_report_icon.f60672b8.svg";